<template>
  <div>
    <span class="box box-link-pop text-center">
      <div class="box-body">
        <div class="row">
          <h5 class="col-6 ">
            <span class="font-weight-bold text-white">Total Earned</span>
            <br /><br />
            <span class="text-success font-weight-normal">
              ${{ current_cap }} USD
            </span>
          </h5>
          <h5 class="col-6 ">
            <span class="font-weight-bold text-white">Maximum Cap</span><br /><br />

            <span class="text-success font-weight-normal">
              ${{ max_cap }} USD
            </span>
          </h5>
        </div>
        <hr />
        <p class="font-size-40 text-white ">
          <strong>
            $<span class="count">{{ Number(regularWallet) }} </span>
            USD
          </strong>
        </p>
      </div>
      <div class="box-body py-25 bg-light">
        <h3 class="font-weight-600 mt-0">
          <i class="icon-wallet"></i>
          Wallet
        </h3>
      </div>
    </span>

    <span class="box box-link-pop text-center" v-if="activationWallet > 0">
      <div class="box-body">
        <p class="font-size-40 text-white ">
          <strong>
            $<span class="count">{{ Number(activationWallet) }} </span>
            USD
          </strong>
        </p>
      </div>
      <div class="box-body py-25 bg-light">
        <h3 class="font-weight-600 mt-0">
          <i class="icon-wallet"></i>
          Activation Wallet
        </h3>
      </div>
    </span>
  </div>
</template>

<script>
export default {
  name: "wallet",
  data() {
    return {
      current_cap: this.$store.getters.currentUser.vault.total_rewards,
      max_cap: this.$store.getters.currentUser.account_max_cap,
      activationWallet: this.$store.getters.currentUser.vault.comissions_amount,
      regularWallet: this.$store.getters.currentUser.vault.amount,
    };
  },
  mounted() {
    this.animation();
  },
  methods: {
    animation() {
      setTimeout(() => {
        $(".count").each(function() {
          $(this)
            .prop("Counter", 0)
            .animate(
              {
                Counter: $(this).text(),
              },
              {
                duration: 4000,
                easing: "swing",
                step: function(now) {
                  $(this).text(parseFloat(now).toFixed(2));
                },
              }
            );
        });
      }, 1000);
    },
  },
};
</script>
